import { render, staticRenderFns } from "./importConfigurationBase.vue?vue&type=template&id=851a3318&"
import script from "./importConfigurationBase.vue.ts?vue&type=script&lang=ts&"
export * from "./importConfigurationBase.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports